import { useLayoutEffect, useState } from "react";

export const useWindowSize = (exposeSize) => {
  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });
  useLayoutEffect(() => {
    function updateSize() {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  if (exposeSize) return size;
  return {
    isMobile: size.width < 768
  };
};
